<template>
  <transition name="fade-thankyou">
    <div class="fullscreen" v-if="show">
      <div class="message-container">
        <transition name="fade-up">
          <p style="position: absolute; bottom: 65%;" v-if="timerSecs > 5">You hear the clunk and hum of the power cycle,<br>the hiss of the cockpit depressurising.</p>
        </transition>
        <transition name="fade-up">
          <p style="position: absolute; bottom: 55%;" v-if="timerSecs > 9">The sun is too bright, and your body aches.</p>
        </transition>
        <transition name="fade-up">
          <p style="position: absolute; bottom: 45%;" v-if="timerSecs > 13">Step out of your mech. Do what you will.</p>
        </transition>
      </div>
      <transition name="fade-up">
        <p v-if="timerSecs > 20" class="small">
          <span @click="hideThankyouHandler">Return</span><br><br>
          Thankyou for playing LOCKDOWN Protocol!<br><br>
          You can come back any time to review your logs,<br>or export them from the settings page.<br><br>
          🖤🖤🖤
        </p>
      </transition>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      timer: 0,
    }
  },
  computed: {
    timerSecs() {
      return this.timer / 1000;
    },
  },
  methods: {
    count() {
      let delay = 250;
      if (this.timer < 21000 && this.$router.currentRoute.name === 'outro') {
        setTimeout(() => {
          this.timer += delay;
          this.count();
        }, delay);
      }
    },
    hideThankyouHandler() {
      this.$emit('hideThankyou');
      this.$router.push({ path: '/' });
    }
  },
  watch: {
    show() {
      this.count();
    }
  }
}
</script>

<style lang="css" scoped>
.fullscreen {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  /* background: white; */
  background: linear-gradient(to top, #e5ffff 0%, #ffd1d1 100%);
}

p {
  width: 100%;
  text-align: center;
}

span {
  text-decoration: underline;
  cursor: pointer;
  padding: 15px;
}

.small {
  position: absolute;
  bottom: 50px;
  font-size: 10px;
  width: 100%;
  text-align: center;
}

.fade-thankyou-enter-active, .fade-thankyou-leave-active {
  transition: opacity 3s;
}
.fade-thankyou-enter, .fade-thankyou-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
